var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_129_289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.75 9.66357C2.75 10.55 2.92459 11.4277 3.26381 12.2467C3.60303 13.0656 4.10023 13.8097 4.72703 14.4365C5.35382 15.0633 6.09794 15.5605 6.91689 15.8998C7.73583 16.239 8.61358 16.4136 9.5 16.4136C10.3864 16.4136 11.2642 16.239 12.0831 15.8998C12.9021 15.5605 13.6462 15.0633 14.273 14.4365C14.8998 13.8097 15.397 13.0656 15.7362 12.2467C16.0754 11.4277 16.25 10.55 16.25 9.66357C16.25 8.77715 16.0754 7.89941 15.7362 7.08046C15.397 6.26151 14.8998 5.5174 14.273 4.8906C13.6462 4.26381 12.9021 3.76661 12.0831 3.42739C11.2642 3.08817 10.3864 2.91357 9.5 2.91357C8.61358 2.91357 7.73583 3.08817 6.91689 3.42739C6.09794 3.76661 5.35382 4.26381 4.72703 4.8906C4.10023 5.5174 3.60303 6.26151 3.26381 7.08046C2.92459 7.89941 2.75 8.77715 2.75 9.66357Z",
    stroke: "#ACACAC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 9.66357L11.75 8.16357",
    stroke: "#ACACAC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 5.91357V9.66357",
    stroke: "#ACACAC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_129_289"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5 0.663574)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo2);
export default __webpack_public_path__ + "static/media/info2.70f210fc7fc7f1abd570ec8d25868d0e.svg";
export { ForwardRef as ReactComponent };